module.exports = __webpack_public_path__ + "img/skills.524a5d6b.png";